import React from "react";
import doctor from "../../assets/images/doctor.png";
import appointment from "../../assets/images/appointment.png";
import PrimaryButtons from "../../assets/components/PrimaryButtons";
import { Fade } from "react-reveal";
import ThreeDImage from "../../ThreeDImage";
import { Link } from "react-router-dom";

const MakeAppointment = () => {
  return (
    <Fade bottom>
      <section
        className="mt-20 font-googFont2 text-2xl"
        style={{ background: `url(${appointment})` }}
      >
        <div className="hero ">
          <div className="hero-content flex-col lg:flex-row">
            <img
              src={doctor}
              className="-mt-32 hidden md:block lg:w-1/2 rounded-lg shadow-2xl"
            />
            <div className="w-1/2">
              <h4 className="text-4xl text-green-400 font-bold py-3">
                Appointment
              </h4>
              <h1 className="text-2xl text-white font-bold">
                Elevate Your Online Experience with Us Today!
              </h1>
              <p className="py-6 text-white">
                Unlock Your Potential by Empowering Minds, Igniting Creativity,
                and Embracing Success!
              </p>
              <button className="btn bg-gradient border-none font-googFont3 text-2xl mb-24 ">
                <Link to="/appointment">Book Appointment</Link>
              </button>
            </div>
          </div>
        </div>
      </section>
    </Fade>
  );
};

export default MakeAppointment;
